import React from "react";
import { TabsContent } from "@/components/ui/tabs";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useState, useEffect } from "react";
import Paginat from "@/components/lib/paginat";
import { useParams } from "react-router-dom";
import { fetchSingleStaffAllAttendanceReport } from "@/redux/slice/staff-management/staff-attendance";
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "@/hooks/useSearch";
import useAuth from "@/hooks/useAuth";
import MonthYearSelector from "@/components/common/month-year-selector";

function AccountActivity() {
  const [monthDate, setMonthDate] = useState(null);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(5);
  const { user } = useAuth();
  const [firstLoading, setFirstLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [searchText, setSearchText] = useState("");

  const { singleStaffPagination, singleStaffAttendance } = useSelector(
    (state) => state.staffManage.attendance
  );

  useEffect(() => {
    const fetchData = async () => {
      if (firstLoading) {
        setFirstLoading(true);
      } else {
        setTableLoading(true);
      }
      const res = await dispatch(
        fetchSingleStaffAllAttendanceReport({
          staff_id: 2,
          date: monthDate,
          page: page,
          limit: perPage,
        })
      );
      if (fetchSingleStaffAllAttendanceReport.fulfilled.match(res)) {
        setFirstLoading(false);
        setTableLoading(false);
      } else if (fetchSingleStaffAllAttendanceReport.rejected.match(res)) {
        setFirstLoading(false);
        setTableLoading(false);
      }
    };
    fetchData();
  }, [user?.user_id, dispatch, page, perPage, monthDate]);

  const searchData = useSearch(
    singleStaffAttendance,
    searchText,
    ["name", "designation"],
    300
  );

  console.log(searchData);
  return (
    <TabsContent className="mt-5" value="account">
      <div>
        <div className="w-full flex justify-between lg:flex-row flex-col gap-5 md:gap-20 items-start lg:items-center mt-5"></div>
        <div className="flex gap-5 justify-between items-end mt-5">
          <div className="flex items-end gap-5">
            <MonthYearSelector
              defaultValue={monthDate}
              onChange={(val) => setMonthDate(val)}
            />
          </div>
          <div className="flex gap-3 justify-center items-center">
            <div className="relative">
              <Search
                size={18}
                className="text-cwhite3 absolute top-2 left-2"
              />
              <Input
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search by Name or ID"
                className="bg-cblack3 pl-8"
              />
            </div>
            <div className="flex gap-1 justify-center items-center">
              <h3 className="text-white">Show</h3>
              <Select
                onValueChange={(value) => setPerPage(Number(value))}
                value={perPage.toString()}
              >
                <SelectTrigger className="w-[60px]">
                  <SelectValue placeholder="10" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="5">5</SelectItem>
                    <SelectItem value="10">10</SelectItem>
                    <SelectItem value="20">20</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="text-white">User ID</TableHead>
                <TableHead className="text-white">Date</TableHead>
                <TableHead className="text-white">Log In</TableHead>
                <TableHead className="text-white">Log Out</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {searchData && searchData.length > 0 ? (
                searchData.map((log, index) => (
                  <TableRow key={index}>
                    <TableCell className="font-medium">
                      {log?.staff_id}
                    </TableCell>
                    <TableCell>
                      <div>{log?.date}</div>
                    </TableCell>
                    <TableCell> {log?.clock_in}</TableCell>
                    <TableCell> {log?.clock_out}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={11} className="text-center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <div>
          <Paginat
            pagination={singleStaffPagination}
            onPageChange={(page) => setPage(page)}
            className="mt-4"
          />
        </div>
      </div>
    </TabsContent>
  );
}

export default AccountActivity;
